
require.register("lodash-compat/internal/isStrictComparable.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "lodash-compat");
  (function() {
    var isObject = require('../lang/isObject');

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;
  })();
});